import Parser from 'html-react-parser'
import { Stack, Text } from 'components'

interface ProjectLearningGoalsProps {
  objectives: string
}

const parseObjectivesAsArray = (objectives: string): string[] | null => {
  try {
    const parsed = JSON.parse(objectives)
    return Array.isArray(parsed) ? parsed : null
  } catch {
    return null
  }
}

const renderAsList = (items: string[]) => (
  <Stack spacing='xs'>
    {items.map((item, index) => (
      <Text key={index}>• {item}</Text>
    ))}
  </Stack>
)

const renderAsHtml = (content: string) => <Text>{Parser(content)}</Text>

export const ProjectLearningGoals = ({ objectives }: ProjectLearningGoalsProps) => {
  const parsedArray = parseObjectivesAsArray(objectives)
  return parsedArray ? renderAsList(parsedArray) : renderAsHtml(objectives)
}
